import {useEffect, useState,} from 'react'
import {
    Box,Spinner,
    Flex, Grid, GridItem,
    Heading, Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    useDisclosure, useToast
} from '@chakra-ui/react'
import Area from "./Area";
import {useParams} from "react-router-dom";
import useCalculator from "../../../core/hooks/useCalculator";
import httpRequest from "../../../core/services/http-request";
import {useGetReport} from "../../../core/hooks";
import {REPORT_TYPE, SPECIFICATIONS_TYPE} from "../../../constants/orders/orderEnum";
import CustomSpinner from '../../../components/Spinner/CustomSpinner';

const LuminsTotal = ({proposal,  setLuminaire, luminaire,project}) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [modalType, setModalType] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const [pdfUrl, setPdfUrl] = useState(null);
    const params = useParams()
    const {calculate, data, isLoading: isLoadingCalculator} = useCalculator(params.reportId)
    const {post, postPdf} = httpRequest()
    const [proposalResponseData, setProposalResponseData] = useState([])
    const [calcNumbers, setCalcNumbers] = useState({})
    const [financed, setFinanced] = useState(0)
    const {data: reportDataResponse, refetch: refetchReport} = useGetReport(params.reportId)
    const [downloadingPDF, setDownloadingPDF] = useState({type: 'pdf', bool: false, id:null})
    const [pdfLoading, setPdfLoading] = useState(null);
    const [ledFinanced, setLedFinanced] = useState([])
    const [projectTotal, setProjectTotal] = useState(0)
    const [totalLoanPdf, setTotalLoanPdf] = useState(0)
    const [totalLoan, setTotalLoan] = useState(0)
    const [yearOneLed, setYearOneLed] = useState(0)
    const toast = useToast();

    console.log(proposal)
    console.log(luminaire)
    console.log(project)

    useEffect(() => {
        if (projectTotal === 0) return
        let total = 0
        let arr = []
        total = (((projectTotal - project.depositAmount) / 100) * project.interestRate) + (projectTotal - project.depositAmount)
        setTotalLoan(total)
        setTotalLoanPdf(total)
        let principalLoanAmount = projectTotal - Number(project.depositAmount)
        let interestDue = principalLoanAmount * Number(project.interestRate)/100
        let totalLoanAmount = principalLoanAmount + interestDue
        let durationYears = Number(project.loanPeriod) / 12
        let annualAmountPaidYear = (totalLoanAmount / durationYears)

        arr.push(project.depositAmount)
        for (let i = 1; i <= 10; i++) {
            if (i <= durationYears){
                arr.push(Math.round((yearOneLed+annualAmountPaidYear)*i))
            } else {
                arr.push(Math.round((yearOneLed*i))+totalLoanAmount)
            }
        }
        setLedFinanced(arr)
        setFinanced(arr)
    }, [projectTotal])


    useEffect(() => {
        if (!proposal) return
        const lumins = []
        for (let i = 0; i < proposal?.proposal?.length; i++) {
            for (let j = 0; j < proposal.proposal[i].luminaires?.length; j++) {
                const item = proposal.proposal[i].luminaires[j]
                const hasRecommendedProduct = item?.lampRecomendedAirtable?.length > 0
                    || item?.fixtureRecomendedAirtableArray?.length > 0
                    || item?.powerSupplyRecomendedAirtableArray?.length > 0
                    || item?.recomendedPowerSupply?.length > 0
                    || Boolean(item?.powerSupplyRecomendedDescription)
                    || item?.controlRecomendedAirtableArray?.length > 0
                    || item?.controlRecomendedAirtable?.length > 0
                    || Boolean(item?.controlRecomendedDescription)
                    || item?.accessoryRecomendedAirtableArray?.length > 0
                    || item?.accessoryRecomendedAirtable?.length > 0
                    || Boolean(item?.accessoryRecomendedDescription)

                if (hasRecommendedProduct) {
                    lumins.push(item)
                }
            }
        }
        let groupedLumins = new Map()
        lumins.forEach((item) => {
            const key = [
                item.fixtureDescription,
                item.lampPerFixture,
                item.lampDescription,
                item.powerSupplyDescription,
                item.controlDescription,
                item.accessoryDescriptionA,
                item.accessoryDescriptionB,
                item.accessoryDescriptionC,
            ].join('|')

            if (groupedLumins.has(key)) {
                groupedLumins.get(key).qty += Number(item.qty);
                groupedLumins.get(key).recomendedFixtureQty += Number(item.recomendedFixtureQty);
            } else {
                groupedLumins.set(key, { ...item, qty: item.qty ? Number(item.qty) : 0, recomendedFixtureQty: item.recomendedFixtureQty ? Number(item.recomendedFixtureQty) : 0 });
            }
        });

        const result = Array.from(groupedLumins.values());
        setLuminaire(result)
    }, [proposal])

    useEffect(() => {
        if (downloadingPDF.bool) {
            downloadReportPdf();
        }
    }, [downloadingPDF]);
    function getCurrentDateFormatted() {
        const currentDate = new Date()
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0')
        const day = currentDate.getDate().toString().padStart(2, '0')
        const year = currentDate.getFullYear().toString().substr(-2)
        return `${month}.${day}.${year}`
    }
    const downloadReportPdf = () => {
        let resp = {
            reportId: params.reportId,
            calculate: calcNumbers,
            totalLoan: totalLoanPdf,
            financed: financed,
            pdfType: downloadingPDF.type === 'spec' ? SPECIFICATIONS_TYPE: SPECIFICATIONS_TYPE,
        }
        postPdf('download-report-luminaire', resp).then((response) => {
            const blob = new Blob([response.data], {type: 'application/pdf'});
            const formattedDate = getCurrentDateFormatted();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${proposalResponseData?.project.address  + ' - ' + formattedDate + ' Luminaire'}.pdf`;
            a.click();
            window.URL.revokeObjectURL(url);
            setDownloadingPDF(false)
        }).catch(() => {
            setDownloadingPDF(false)
            toast({
                title: "Failed to load PDF",
                description: "Some items are missing in the created report. Please try again.",
                status: "error",
                duration: 4000,
                isClosable: true,
                position: "top-right",
            });
        })
    }
    const previewReportPdf = (item) => {
        setPdfLoading(item.id);
        let resp = {
            reportId: params.reportId,
            calculate: calcNumbers,
            totalLoan: totalLoanPdf,
            financed: financed,
            pdfType: SPECIFICATIONS_TYPE,
        };
        postPdf('download-report-luminaire', resp)
            .then((response) => {
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                setPdfUrl(url);
                setSelectedItem(item);
                setModalType("pdf");
                onOpen();
            })
            .catch(() => {
                setPdfUrl(null);
                setPdfLoading(null);
                toast({
                    title: "Failed to load PDF",
                    description: "Something went wrong while generating the preview. Please try again.",
                    status: "error",
                    duration: 4000,
                    isClosable: true,
                    position: "top-right",
                });
            });
    };
    const normalizeDimensions = value => value?.replace(/"?(\d+(?:\.\d+)?)"?/g, '$1"');
    useEffect(() => {
        if (!reportDataResponse) return
        calculate()
        setProposalResponseData(reportDataResponse.data.data)
    }, [reportDataResponse])
    useEffect(() => {
        if (!data) return
        let results = data.data.data
        results.installation = proposalResponseData?.installation?.total ? proposalResponseData?.installation?.total?.toLocaleString('en-US') : 0
        setCalcNumbers(results)
        setProjectTotal(results.projectTotal)
        setYearOneLed(results.yearOneLed)
    }, [data])
    return (
        <>
            <Flex mt={10} justifyContent='space-around' mb={4}>
                <Box w='48%' borderBottomWidth="1px" borderColor="grey.200">
                    <Heading m={0} pb={2} color="#757575" textAlign='center' fontSize="xl">
                        EXISTING COMPONENTS
                    </Heading>
                </Box>
                <Box w='48%' borderBottomWidth="1px" borderColor="#8FCF74">
                    <Heading m={0} color="#428027" textAlign='center' fontSize="xl">
                        RECOMMENDED COMPONENTS
                    </Heading>
                </Box>
            </Flex>
            <Heading
                fontSize='18px'
                mb={3}
                mt={0}
                alignItems='center'
                w='full'
                color='#193C5B'
                fontWeight='700'>
                Totals
            </Heading>
            {luminaire?.map((item) => (
                <Flex maxW="1240px" key={item.id} mb={2}>
                    <Box flex={1} mr={6} p={1} minH='45px' border="1px solid #C4C4C4" fontSize="12px" color='#757575'>
                        {/*{item.recomendedLampQty*/}
                        {/*    ? '[' + (item.recomendedFixtureQty * item.recomendedLampQty) + '] '*/}
                        {/*    : '[' + (item.recomendedFixtureQty + '] ')*/}
                        {/*}*/}
                        {/*{item.recomendedFixtureQty ? item.recomendedFixtureQty : item.globalRecomendedFixtureQty ? item.globalRecomendedFixtureQty : luminaire.qty*/}
                        {/*    ? luminaire.qty * luminaire.lampPerFixture*/}
                        {/*    : luminaire.globalQty * luminaire.lampPerFixture}*/}
                        {
                            item.recomendedFixtureQty ? '[' + item.recomendedFixtureQty  + '] '
                                : item.globalRecomendedFixtureQty ? item.globalRecomendedFixtureQty
                                    : item.qty
                                        ?  '['  + item.qty + '] '
                                        : '[' + item.globalQty * item.lampPerFixture + '] '
                        }
                        {normalizeDimensions(item.fixtureDescription ? item.fixtureDescription +' ': '')}
                        {/*{item.recomendedLampQty ? `[${item.recomendedLampQty}] ` : ''}*/}
                        {item.lampPerFixture ? '('+item.lampPerFixture+')' +' ': ''}
                        {item.lampDescription ? item.lampDescription +' ': ''}
                        {item.powerSupplyDescription ? 'powered by ' + `(${item.powerSupplyRecomendedQty})` +  ' ' +item.powerSupplyDescription +' ': ''}
                        {item.controlDescription ? 'controlled by ' + `(${item.controlRecomendedQty})` + ' ' + item.controlDescription +' ': ''}
                        {item.accessoryDescriptionA ? 'with ' + `(${item.accessoryRecomendedQty})` +  ' ' +  item.accessoryDescriptionA +' ': ''}
                        {item.accessoryDescriptionB ? ', '+item.accessoryDescriptionB +' ': ''}
                        {item.accessoryDescriptionC ? ', '+item.accessoryDescriptionC +' ': ''}
                        {item.fixtureMountHeight ? '{'+item.fixtureMountHeight+'}' +' ': ''}
                    </Box>
                    <Grid
                        templateColumns="3fr 1fr"
                        flex={1}
                        p={1}
                        minH="45px"
                        border="1px solid #8FCF74"
                        fontSize="12px"
                        color="#428027"
                        align="center"
                    >
                        <GridItem>
                            {/*<pre>{JSON.stringify(item, null, 2)}</pre>*/}
                            {/*{item.recomendedLampQty*/}
                            {/*    ? '[' + (item.recomendedFixtureQty * item.recomendedLampQty) + '] '*/}
                            {/*    : '[' + (item.recomendedFixtureQty + '] ')*/}
                            {/*}*/}
                            {/*{item.recomendedFixtureQty ? item.recomendedFixtureQty : item.globalRecomendedFixtureQty ? item.globalRecomendedFixtureQty : item.recomendedLampQty}*/}

                            {
                                item.recomendedFixtureQty ? '[' + item.recomendedFixtureQty + '] '
                                    : item.globalRecomendedFixtureQty ? '[' + item.globalRecomendedFixtureQty + '] '
                                        : item.qty
                                            ?  '[' + item.qty + '] '
                                            : '[' + item.globalQty * item.lampPerFixture + '] '
                            }
                            {/*{item.recomendedFixtureQty ? `[${item.recomendedFixtureQty}] ` : ''}*/}
                            {item.fixtureRecomendedDescription ? item.fixtureRecomendedDescription + ' ' : ''}
                            {item.lampRecomendedDescription && item.recomendedLampQty ? `(${item.recomendedLampQty}) ` : ''}
                            {item.lampRecomendedDescription ? item.lampRecomendedDescription + ' ' : ''}
                            {item.powerSupplyRecomendedDescription ? 'powered by ' + `(${item.powerSupplyRecomendedQty})` + ' ' +  item.powerSupplyRecomendedDescription + ' ' : ''}
                            {item.controlRecomendedDescription ? 'controlled by ' + `(${item.controlRecomendedQty})` + ' ' + item.controlRecomendedDescription + ' ' : ''}
                            {item.accessoryRecomendedDescription ? 'with ' + `(${item.accessoryRecomendedQty})` +  ' ' + item.accessoryRecomendedDescription + ' ' : ''}
                            {item.fixtureMountHeight ? `{${item.fixtureMountHeight}}` : ''}
                        </GridItem>
                        <GridItem pr='13px' display="flex" justifyContent='flex-end'  alignItems='center'
                        >
                            <Flex gap={2}  display="flex"  alignItems='center'>
                                <Box as="span" cursor="pointer"  display="flex"  alignItems='center'>
                                    {pdfLoading === item.id ? (
                                        <Spinner
                                            thickness="2px"
                                            speed="0.45s"
                                            color="gray.400"
                                            boxSize="12px"
                                        />
                                    ) : (
                                        <img
                                            src="/icons/eye_icon.svg"
                                            onClick={() => previewReportPdf(item)}
                                            alt="eye_icon"
                                        />
                                    )}
                                </Box>
                                <Box as="span" cursor="pointer" display="flex"  alignItems='center'>
                                    {downloadingPDF.bool && downloadingPDF.id === item.id ? (
                                        <Spinner
                                            thickness="2px"
                                            speed="0.45s"
                                            color="gray.400"
                                            boxSize="12px"
                                        />
                                    ) : (
                                        <img
                                            src="/icons/cloud_upload.svg"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setDownloadingPDF({ type: 'print', bool: true, id: item.id })
                                            }}
                                            alt="cloud_upload"
                                        />
                                    )}
                                </Box>
                            </Flex>
                        </GridItem>
                    </Grid>
                </Flex>
            ))}
            <Box pt={7} m='auto' maxWidth='1240px'>
                {proposal?.proposal?.filter((filtered) => filtered?.luminaires?.length > 0).map((item) => (
                    <Area
                        recentProposal={item}
                        key={item.id}
                        data={item}
                        areaName={item.title}/>
                ))}
            </Box>
            <Modal isOpen={isOpen} onClose={onClose} size="6xl">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>
                        {modalType === "view" ? "View Item Details" : proposal?.proposalName}
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {modalType === "pdf" && pdfUrl && (
                            <Box h="600px">
                                <iframe
                                    src={pdfUrl}
                                    width="100%"
                                    height="100%"
                                    style={{ border: "none" }}
                                    title="PDF Preview"
                                    onLoad={() => setPdfLoading(null)}
                                />
                            </Box>
                        )}

                        {modalType === "delete" && (
                            <Box>Are you sure you want to delete this item?</Box>
                        )}
                    </ModalBody>

                </ModalContent>
            </Modal>
        </>
    )
}

export default LuminsTotal
